export default "__VITE_ASSET__DYQnTuyP__"